<script>
import baseEdit from "@/views/components/base/baseEdit.vue";

export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "sysTask",
      key: "id",
      url: {},
      items: [
        { label: "基本信息", desc: "表单的基本信息", type: "header" },
        {
          label: "申请内容",
          name: "applyContent",
          value: "",
          type: "textarea",
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "申请文件",
          name: "applyFileUrl",
          value: "",
          type: "documents",
          desc: "",
          handleRemove: this.handleRemove,
        },
        {
          label: "负责人",
          name: "finishId",
          value: "",
          type: "select",
          width: "400px",
          dropList: [],
          rules: [
            {
              required: true,
              message: "负责人不能为空",
              trigger: "blur",
              type: "number",
            },
          ],
        },
        {
          label: "紧急程度",
          name: "emergencyDegree",
          type: "select",
          width: "400px",
          value: "1",
          dropList: [
            {
              value: 1,
              name: "一般",
            },
            {
              value: 2,
              name: "较重",
            },
            {
              value: 3,
              name: "重要",
            },
            {
              value: 4,
              name: "特别重要",
            },
          ],
        },
        {
          label: "任务状态",
          name: "state",
          type: "select",
          width: "400px",
          value: 1,
          dropList: [
            {
              value: 1,
              name: "未完成",
            },
            {
              value: 2,
              name: "已完成",
            },
          ],
          onChange: this.onisParent,
        },

        {
          label: "结果文件",
          name: "resultFileUrl",
          value: "",
          type: "documents",
          desc: "",
          handleRemove: this.handleRemove,
        },
        {
          label: "结果内容",
          name: "finishContent",
          value: "",
          type: "textarea",
          width: "400px",
        },
        { label: "备注", name: "remark", value: "", type: "textarea", width: "400px" },
      ],
      forms: {
        building: "",
        address: "",
      },
    };
  },
  created() {
    this.loadAdminUserData();
  },
  mounted() {
    this.onisParent(1);
  },
  methods: {
    initData() {
      // 加载详情数据
      let id = this.kv;
      $utils.api.load(`/admin/system/task/${id}`, {}).then((res) => {
        if (res && res.data) {
          this.forms = res.data;
          if (res.data.state == 1) {
            this.onisParent(1);
          } else {
            this.onisParent(2);
          }
        }
      });
    },
    //1代表存在父级
    //0代表不存在父级
    onisParent(val) {
      if (val == 1) {
        this.items[this.getItemIndex("resultFileUrl")].type = "kong";
        this.items[this.getItemIndex("finishContent")].type = "kong";
      }
      if (val == 2) {
        this.items[this.getItemIndex("resultFileUrl")].type = "documents";
        this.items[this.getItemIndex("finishContent")].type = "textarea";
      }
    },
    async handleSubmit() {
      if (!this.action) {
        return true;
      }
      let q = this.forms;
      await this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
            .load(`/admin/system/task`, q, this.action == "edit" ? "PUT" : "POST")
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
                $utils.url.go(-1);
              }
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
            });
        }
      });
    },

    //选择处理人下拉框
    async loadAdminUserData() {
      // 通过pk查询字典数据
      console.log(1111);
      let q = {};
      let res = await $utils.api.load("/admin/system/user/listPrincipal", q);
      if (res && res.rows) {
        let ll = res.rows;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.id;
          xx.name = element.nickName;
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "finishId") {
            this.items[index]["dropList"] = dropList;
          }
        }
      }
    },
  },
};
</script>
